/*
 *
 *  Category
 *  contains basic js for the category page
 *  !! Created by Charlotte on 10/07/2017
 *
 */

import '../cart.js';
var allowedUrlFilters = null;

$(document).ready(function () {
    // Initialize
    InitPager();
    InitSortorder();
    InitFilters();
    InitAddToCart();
    InitViewSelect();
    InitExplicitContent();
    InitSelectedFilters();
    InitSelectedBookLanguage();
    CheckActiveFilters();
    InitFilterText();
    InitRelatedSeries();
    //InitRemove();

    $('button.in-cart').on('click', function() {
        window.location.href = strCartUrl;
    });
    //When changing serie to order change price
    $('.load').on('change', '#seriestype', function () {
        $('#priceseries span').html($(this).val());
    });

    //Order the series
    $('.load').on('click', '#order_series', function () {
        var button = $(this);
        var strParams = 'strProductsFull=' + $('#seriestype option:selected').data('articles');

        button.find('i[class*="shopping"]').addClass('d-none');
        button.find('i[class*="spinner"]').removeClass('d-none');

        // Add items to cart
        $.post(strAjaxPath + 'cart/cart.php', strParams, function (data) {
            button.find('i[class*="spinner"]').addClass('d-none');
            button.find('i[class*="check"]').removeClass('d-none');

            // Update mini cart in pagehead
            UpdateMiniCart();
        }, 'json');
    });


    $('main').on('click', 'a.trigger', function () {
        $(this).next().toggleClass('d-block d-none');
        return false;
    });


    $.getJSON(strAjaxPath + 'get-url-filters.php', function (data) {
        if (data != null) {
            allowedUrlFilters = data.map(d => parseInt(d));
        }
    });
});

function CheckActiveFilters() {
    var numberOfActiveFilters = $('aside.pageleft a.active').length;
    var objConfirmBtn = $('aside.pageleft button.toggle-filters');
    var objClose = objConfirmBtn.find('.close-txt');
    var objConfirm = objConfirmBtn.find('.confirm');
    var objIcon = objConfirmBtn.find('i');


    if (numberOfActiveFilters > 1) {
        objConfirm.removeClass('d-none');
        objConfirm.addClass('d-inline-block');
        objClose.addClass('d-none');
        objClose.removeClass('d-inline-block');
        objIcon.addClass('fa-check');
        objIcon.removeClass('fa-times');
        objConfirmBtn.addClass('bg-success');
        objConfirmBtn.removeClass('bg-black');
    } else {
        objConfirm.addClass('d-none');
        objConfirm.removeClass('d-inline-block');
        objClose.removeClass('d-none');
        objClose.addClass('d-inline-block');
        objIcon.removeClass('fa-check');
        objIcon.addClass('fa-times');
        objConfirmBtn.removeClass('bg-success');
        objConfirmBtn.addClass('bg-black');
    }
}

/*function InitRemove() {
    $("button.remove").unbind();
    $("button.remove").click(function () {
        var strValue = $(this).closest('div.filters').find("input[type='text']").val();
        var strNewUrl = $("div.selected-filters a[data-filter='" + strValue + "']").attr("href");
        window.history.pushState({path: strNewUrl}, '', strNewUrl);

        //-- Clear value
        $(this).closest('div.filters').find('input[type=text]').val('');
        $(this).closest('div.filters').find('input[type=text]').removeAttr('readonly');
        $(this).closest('div.filters').find('button i').attr('class', 'fal fa-search');

        // Load articles
        LoadArticlesWithoutFilters();

        // Scroll to top catalog overview
        $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
        return false;
    });
}*/

function InitPager() {
    $('.pagination a').click(function () {
        // Change url page
        var strNewUrl = $(this).attr('href');
        window.history.pushState({path: strNewUrl}, '', strNewUrl);

        // Load articles
        LoadArticles();

        // Scroll to top catalog overview
        $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
        return false;
    });
}

function InitSortorder() {
    // Update sortorder
    $('button[data-type="sortorder"]').click(function () {
            // Save sortorder in session
            $.post(strAjaxPath + 'catalog-sort.php', 'value=' + $(this).attr('data-value'), function (objResponse) {
                // Load articles
                LoadArticles();
            }, 'json');
            return false;
        },
    );
}

function InitViewSelect() {
    // Update view
    $('button[data-id="view"]').click(function () {
            // Save sortorder in session
            $.post(strAjaxPath + 'catalog-view.php', 'value=' + $(this).attr('data-view'), function () {
                // Load articles
                LoadArticles();
            }, 'json');
            return false;
        },
    );
}

function InitExplicitContent() {
//Show explicit content picture
    $('button[data-id="show_explicit_content"]').click(function () {
        // Save sortorder in session
        $.post(strAjaxPath + 'explicit_content.php', 'value=' + $(this).attr('data-value'), function () {
            // Load articles
            LoadArticles();
        }, 'json');
        return false;
    });
}

function InitFilters() {
    $('input[name=\'searchtitle\']').blur(function (e) {
        // Change url page
        var strNewUrl = UpdateQueryString();
        window.history.pushState({path: strNewUrl}, '', strNewUrl);

        // Load articles
        LoadArticles();

        // Scroll to top catalog overview
        $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
        return false;
    });

    $('div.filter-scroll a').unbind('click');
    $('div.filter-scroll a').click(function () {
        $(this).toggleClass('active');

        // Change url page
        var strNewUrl = UpdateQueryString();
        window.history.pushState({path: strNewUrl}, '', strNewUrl);

        // Load articles
        LoadArticles();


        // Scroll to top catalog overview
        $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
        return false;
    });

    //--Load filters
    $('div.filter-scroll').unbind('scroll');
    $('div.filter-scroll').not('.filter-search').on('scroll', function () {
        if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
            var objFilter = $(this);
            var intFilter = objFilter.attr('data-filter');
            var intOffset = objFilter.find('a').length;
            var strProductsFull = $('input#strProductsFull').val();
            var strSelectedFilters = $('input#strSelectedFilters').val();
            var intCategoryNo = $('input#intCategoryNo').val();

            $.post(strAjaxPath + 'load-filter.php', {intFilter, strProductsFull, intOffset, strSelectedFilters, intCategoryNo}, function (data) {
                if (data != '') {
                    objFilter.append(data);
                    InitFilters();

                }
            }, 'html');
        }
    });

    $('.toggle-filters').unbind('click touchstart');
    $('.toggle-filters').on('click touchstart', function () {
        $('body').toggleClass('filters-open');
        return false;
    });

    //-- Scroll
    $('a[data-scroll]').click(function () {
        $('html, body').animate({
            scrollTop: $('div[data-scroll-to="' + $(this).attr('data-scroll') + '"]').offset().top,
        }, 800);
    });

    // Mail on stock
    if (WebsiteSettingBlnMailOnStock) {
        // Clicking on button from mail on stock => ajax form
        $('input#btnMailStock').click(function () {
            MailOnStock();
        });

        $('input#txtEmailStock').on('keyup', function (e) {
            if (e.which == 13) {
                MailOnStock();
                return false;
            }
        });
    }

    CheckActiveFilters();
}

function LoadArticles(categoryno) {
    // Show loader after a small delay
    var objLoader = $('.overlay-loader-ajax');

    if (objLoader.length) {
        objLoader.addClass('d-flex');
        objLoader.removeClass('d-none');
        //objLoader.find('.suggestion-loader').addClass('active');
    }

    // Set parameters
    var strFilterLoad = '';
    if (window.location.href.indexOf('?') <= -1) {
        strFilterLoad = '?filterload=1';
    } else {
        strFilterLoad = '&filterload=1';
    }

    if (categoryno && categoryno > 0) {
        strFilterLoad += '&categoryno=' + encodeURIComponent(categoryno);
    }

    // Load page
    $('div.load').load(window.location.href + strFilterLoad, function () {
        objLoader.removeClass('d-flex');
        objLoader.addClass('d-none');
        //objLoader.find('.suggestion-loader').removeClass('active');

        // Check if product overview is visible
        var blnInViewPort = ElementInViewport($('div.load'));

        if (blnInViewPort === false) {
            $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
        }

        if (intCategoryNo > 0) {
            if (categoryno && categoryno > 0) {
                intCategoryNo = encodeURIComponent(categoryno);
            }

            if ($('input#intCategoryNo').length > 0) {
                intCategoryNo = $('input#intCategoryNo').val();
            }

            // Filters aanpassen
            let strProductsFull = $('input#strProductsFull').val() === undefined ? '' : $('input#strProductsFull').val();
            $.post(strAjaxPath + 'catalog-filters.php', 'intCategoryNo=' + intCategoryNo + '&strTypePageLeft=' + strTypePageLeft + '&strSearchTitle=' + $('input[name="searchtitle"]').val() + '&strSelectedFilters=' + $('input#strSelectedFilters').val() + '&strProductsFull=' + strProductsFull, function (objResponse) {
                // Filters opnieuw inladen
                $('div.filter-wrapper').html(objResponse);

                // Initialize
                InitPager();
                InitSortorder();
                InitViewSelect();
                InitExplicitContent();
                InitFilters();
                InitAddToCart();
                InitSelectedFilters();
                InitSelectedBookLanguage();
                CheckActiveFilters();
                InitFilterText();
                InitRelatedSeries();
            }, 'html');
        } else {
            // Initialize
            InitPager();
            InitSortorder();
            InitViewSelect();
        }

        $.post(strAjaxPath + 'get-filter-meta-info.php', 'strUrl=' + encodeURIComponent(window.location.href), function (res) {
            if (res !== null) {
                try {
                    let parsedRes = JSON.parse(res);
                    if (parsedRes.pagetitle) {
                        $('title').text(parsedRes.pagetitle);
                        $('meta[property="og:title"]').attr('content', parsedRes.pagetitle);
                    } else {
                        $('title').text($('meta[name="original-title"]').attr('content'));
                        $('meta[property="og:title"]').attr('content', $('meta[name="original-opengraphtitle"]').attr('content'));
                    }

                    if (parsedRes.pagedescription) {
                        $('meta[name="description"]').attr('content', parsedRes.pagedescription);
                        $('meta[property="og:description"]').attr('content', parsedRes.pagedescription);
                    } else {
                        let originalDescription = $('meta[name="original-description"]').attr('content');
                        $('meta[name="description"]').attr('content', originalDescription);
                        $('meta[property="og:description"]').attr('content', originalDescription);
                    }
                } catch (e) {
                    console.error("Error parsing JSON response: ", e);
                }
            }
        });
    });
}

function LoadArticlesWithoutFilters() {
    // Show loader after a small delay
    var objLoader = $('.overlay-loader-ajax');

    if (objLoader.length) {
        objLoader.addClass('d-flex');
        objLoader.removeClass('d-none');
        //objLoader.find('.suggestion-loader').removeClass('active');
    }

    // Set parameters
    var strFilterLoad = '';
    if (window.location.href.indexOf('?') <= -1) {
        strFilterLoad = '?filterload=1';
    } else {
        strFilterLoad = '&filterload=1';
    }

    // Load page
    $('div.load').load(window.location.href + strFilterLoad, function () {
        objLoader.removeClass('d-flex');
        objLoader.addClass('d-none');
        //objLoader.find('.suggestion-loader').removeClass('active');

        // Check if product overview is visible
        var blnInViewPort = ElementInViewport($('div.load'));

        if (blnInViewPort === false) {
            $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
        }

        // Initialize
        InitPager();
        InitSortorder();
        InitViewSelect();
        InitExplicitContent();
        InitAddToCart();
        InitSelectedFilters();
        InitSelectedBookLanguage();
        CheckActiveFilters();
        InitFilterText();
        InitRelatedSeries();
    });
}

function ElementInViewport(objElement) {
    //special bonus for those using jQuery
    if (objElement instanceof jQuery) {
        objElement = objElement[0];
    }

    var top = objElement.offsetTop;
    var left = objElement.offsetLeft;
    var width = objElement.offsetWidth;
    var height = objElement.offsetHeight;
    while (objElement.offsetParent) {
        objElement = objElement.offsetParent;
        top += objElement.offsetTop;
        left += objElement.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}


// Add to cart
function InitAddToCart() {
    AddToCart($('form.form-add-to-cart button.btn-basket'), false, true, false);
}


function InitSelectedFilters() {
    //--Reset filters
    $('a.clearall').on('click', function () {
        $('div.filter-scroll a').removeClass('active');

        //--Url wijzigen
        var strNewUrl = UpdateQueryString();
        window.history.pushState({path: strNewUrl}, '', strNewUrl);

        //--Artikelen filteren
        LoadArticles();
        return false;
    });

    $('div.selected-filters a').on('click touchstart', function () {
        var strFilter = $(this).attr('data-filter');

        if (strFilter == 'all') {
            $('div.filter-scroll a').removeClass('active');
        } else {
            $('div.filter-scroll a[data-itemno=\'' + strFilter + '\']').removeClass('active');
        }

        //--Url wijzigen
        var strNewUrl = UpdateQueryString();
        window.history.pushState({path: strNewUrl}, '', strNewUrl);

        //--Artikelen filteren
        LoadArticles();
        return false;
    });
}


function InitSelectedBookLanguage() {
    $('#book_language_switch input[name="switchlang"]').on('click', function () {
        $('input[name=\'searchtitle\']').val('');

        //--Url wijzigen
        var strNewUrl = $(this).data('url');
        var strNewCategory = $(this).data('category');

        window.history.pushState({path: strNewUrl}, '', strNewUrl);

        var lang_id = $(this).attr('id').replace('switchlang_', '');

        //Set session
        $.post(strAjaxPath + 'catalog-lang.php', 'lang=' + lang_id, function (data) {
        });

        //--Artikelen filteren
        LoadArticles(strNewCategory);
        return false;
    });
}

function UpdateQueryString() {
    var strReturnUrl = $('input#strThisUrl').val();
    var arrSelectedFilters = new Object();
    var strSelectedFiltersUrl = '';
    var strSearchTitle = $('input[name=\'searchtitle\']').val();
    var arrSelectedLabels = [];
    $('div.filter-scroll a').each(function () {
        //--Geselecteerde filters ophalen
        if ($(this).hasClass('active')) {
            var intId = $(this).parent().attr('data-filter');
            var intValue = $(this).attr('data-itemno');
            var strLabel = formatFilterLabel(String($(this).data('url-name')));

            if(allowedUrlFilters !== null && allowedUrlFilters.includes(parseInt(intId)) && !arrSelectedLabels.includes(strLabel)){
                arrSelectedLabels.push(strLabel);
            }

            if (arrSelectedFilters[intId] === undefined) {
                arrSelectedFilters[intId] = new Array(intValue);
            } else {
                if ($.inArray(intValue, arrSelectedFilters[intId]) < 0) {
                    arrSelectedFilters[intId].push(intValue);
                }
            }
        }
    });

    //--Opbouwen filter url
    if (Object.keys(arrSelectedFilters).length > 0) {
        $.each(arrSelectedFilters, function (intKey, intValue) {
            //for (intKey in arrSelectedFilters) {
            if (strSelectedFiltersUrl != '') {
                strSelectedFiltersUrl += '&';
            }

            strSelectedFiltersUrl += intKey + '=' + arrSelectedFilters[intKey].join();
        });
    }

    if (strSearchTitle != '' || strSelectedFiltersUrl != '') {
        strReturnUrl += '?';
        if (typeof strSearch !== 'undefined') {
            strReturnUrl += 'text=' + strSearch + '&';
        }
    } else {
        if (typeof strSearch !== 'undefined') {
            strReturnUrl += '?text=' + strSearch;
        }
    }

    if (strSelectedFiltersUrl != '') {
        strReturnUrl += strSelectedFiltersUrl;
    }

    if (strSearchTitle != '') {
        if (strSelectedFiltersUrl != '') {
            strReturnUrl += '&';
        }
        strReturnUrl += 'title=' + strSearchTitle;
    }

    if (typeof strType !== 'undefined') {
        strReturnUrl += '&type=' + strType;
    }

    if (typeof blnSearchAll !== 'undefined' && blnSearchAll === true) {
        strReturnUrl += '&all=1';
    }

    var strLabelsUrlPart = arrSelectedLabels.length > 0 ? arrSelectedLabels.join('_') + '/' : '';
    var returnUrlParts = strReturnUrl.split('/').filter(p => p !== '');
    if (returnUrlParts.length >= 2) {
        strReturnUrl = '/' + returnUrlParts[0] + '/' + strLabelsUrlPart + returnUrlParts.slice(-1);
    }

    return strReturnUrl;
}

function MailOnStock() {
    var objInput = $('input#txtEmailStock');
    var objInputParent = objInput.parent();

    // Check if there's a correct e-mail entered => then add request to database
    $.post(strAjaxPath + 'mail-on-stock.php', 'intSerieNo=' + $('input#hdnSerieNo').val() + '&strEmailStock=' + $('input#txtEmailStock').val(), function (data) {

        $('label[for="txtEmailStock"]').remove();
        objInput.removeClass('is-invalid');

        if (data.value == 0) {
            // Error
            objInput.addClass('is-invalid');
            objInputParent.append('<label class="d-flex invalid-feedback" for="txtEmailStock">' + data.message + '</label>');
        } else {
            // Notitication
            objInputParent.parent().hide();
            objInputParent.parent().parent().append('<div class="alert alert-success">' + data.message + '</div>');
        }
    }, 'json');
}

function formatFilterLabel(label) {
    return encodeURIComponent(
        label
            .replace(/\s*\(\d+\)$/, '')
            .trim()
            .toLowerCase()
            .replace(/ - /g, '-')
            .replace(/ /g, '-')
    );
}

function InitFilterText(){
    let txtFilterPage = $('.txt-filter-page');
    let imgFilterPage = txtFilterPage.parent().next().find('figure img');

    function adjustHeight(){
        txtFilterPage.css('height', (imgFilterPage.height() + 10) + 'px');

        // Create toggle button only if the content is overflowing
        if (txtFilterPage && txtFilterPage.prop('scrollHeight') > (txtFilterPage.height() + 5)) {
            $.get(strAjaxPath + 'get-toggle-button.php', '', function (data) {
                const toggleLink = $(data);
                let icon     = toggleLink.find('span.icon');
                let showMore = toggleLink.find('span.showmore');
                let showLess = toggleLink.find('span.showless');

                toggleLink.click(function(event) {
                    event.preventDefault();
                    if (!txtFilterPage.hasClass('show')) {
                        icon.removeClass('fa-arrow-down').addClass('fa-arrow-up');
                        showMore.addClass('d-none');
                        showLess.removeClass('d-none');
                    } else {
                        toggleLink.find('span.icon').removeClass('fa-arrow-up').addClass('fa-arrow-down');
                        showLess.addClass('d-none');
                        showMore.removeClass('d-none');
                        $('html,body').animate({scrollTop: txtFilterPage.offset().top - 100}, 'fast');
                    }
                    txtFilterPage.toggleClass('show');
                });

                txtFilterPage.parent().append(toggleLink);
            });
        }
    }

    imgFilterPage.each(function() {
        if (this.complete) {
            adjustHeight();
        } else {
            $(this).on('load', adjustHeight);
        }
    });
}

function InitRelatedSeries() {
    let relatedSeries = $('.related-series');
    if (relatedSeries.length > 0) {
        attachToggleButtonHandler(relatedSeries);
    }
}

function attachToggleButtonHandler(relatedSeries) {
    let toggleButton = relatedSeries.find('.series.toggle-button');
    if (toggleButton.length > 0) {
        toggleButton.click(function(e) {
            e.preventDefault();
            let showMore = $(this).find('.type').hasClass('showmore');
            let filterItemNo = relatedSeries.data('filteritemno');
            let techDetailNo = relatedSeries.data('techdetailno');
            // let limit = relatedSeries.find('.series-block').length + 5;
            let limit = showMore ? 0 : 5;
            $.get(strAjaxPath + 'get-related-series.php', 'filteritemno=' + filterItemNo + '&techdetailno=' + techDetailNo + '&limit=' + limit, function (data) {
                let newRelatedSeries = $(data);
                relatedSeries.replaceWith(newRelatedSeries);
                attachToggleButtonHandler(newRelatedSeries);

                if(!showMore){
                    let newRelatedSeriesDiv = $('div.related-series');
                    $('html,body').animate({scrollTop: newRelatedSeriesDiv.offset().top - 100}, 'fast');
                }
            });
        });
    }
}

window.InitExplicitContent = InitExplicitContent;
window.InitViewSelect = InitViewSelect;
window.InitAddToCart = InitAddToCart;
window.ElementInViewport = ElementInViewport;
window.LoadArticles = LoadArticles;
window.LoadArticlesWithoutFilters = LoadArticlesWithoutFilters;
window.InitSortorder = InitSortorder;
window.InitFilters = InitFilters;
window.InitPager = InitPager;
window.CheckActiveFilters = CheckActiveFilters();

//window.InitRemove = InitRemove;